
import plugin from './index'
Vue.use(plugin)
